import InputSystem from './InputSystem';
import './InputSystem.scss';

export default InputSystem;
